import {
  AdminLogin,
  AdminDashboard,
  Dashboard,
  VendorLogin,
  Addbulkproducts,
  LegalprivacyPolicy,
  CommunicationManagement,
  PaymentManagement,
  AdminFinancialManagement,
  AdminSettings,
  ReturnandRefundPolicy,
  IntegrationwithDeliverySystem,
  OrderStatus,
  MarketingandPromotion,
  VendorProduct,
  ProfilePage,
} from "./pages";
import { useState } from "react";

import "./App.css";
import PageShell from "./components/Layout/PageShell";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Provider } from "react-redux";
import configureStore from "./store/index";
import { PersistGate } from "redux-persist/integration/react";
import Home from "./pages/user/Home";
import Products from "./pages/user/Categorys";
import Header from "./components/Header/userHeader";
import Footer from "./components/Footer/userFooter";
import ShopDetails from "./pages/user/ShopDetails";
import ListingShopDetails from "./pages/user/ListingShopDetails";
import { ProtectedRoute } from "./routes";
// import { OTPVerification } from "./components/Login/OTPVerification";

import {
  CartPage,
  CreateAccount,
  Login,
  PaymentOptions,
  ProfileInformation,
  OTPVerification,
} from "./components";
import SignUp from "./components/CreateAccount/createAccount";
import Categorys from "./pages/user/Categorys";
import Toplist from "./pages/user/Toplist";
import { Seeallcategories } from "./components/Categories/Seeallcategories";
import Seealltopratingshops from "./components/TopRatingShops/Seealltopratingshops";
import SeeallnearbyShopsSection from "./components/NearByShops/SeeallnearbyShopsSection";
import Vendorseller from "./components/Header/Vendorseller";
import { SeeallTopListSeraches } from "./components/Categories/seeallTopListSearches";
import { SnackBarNotification } from "./components";
import AboutUs from "./pages/AboutUs";
import HelpCenter from "./pages/HelpCenter";
import SeoUpdater from "./components/SEO/SeoUpdater";

import Termsconditions from "./pages/Termsconditions";
import Privacypolicy from "./pages/Privacypolicy";
import Vendoragreement from "./pages/Vendoragreement";
// import ProfilePage from "./pages/vendor/dashboard/ProfilePage";

// import {AdminLogin,Adm} from './pages/admin/Login';

// const store = configureStore();
const { store, persistor } = configureStore();

function App() {
  const SignupFlow = () => {
    const [step, setStep] = useState(1);

    return (
      <div>
        {step === 1 && <CreateAccount onNext={() => setStep(2)} />}
        {step === 2 && <OTPVerification />}
      </div>
    );
  };

  const location = useLocation();
  // Only routes that do NOT render their own Header/Footer (see Home, ProfileInformation, AboutUs, etc.)
  const showHeaderFooter =
    location.pathname.startsWith("/category") ||
    location.pathname.startsWith("/toplist") ||
    location.pathname.startsWith("/shop") ||
    location.pathname.startsWith("/vendorshop") ||
    location.pathname.startsWith("/cart") ||
    location.pathname.startsWith("/payment") ||
    location.pathname.startsWith("/help-center");

  return (
    <PageShell sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <SeoUpdater />
      {showHeaderFooter && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/category/:id" element={<Categorys />} /> */}
        <Route path="/category/:categoryName" element={<Categorys />} />
        <Route path="/toplist/:category" element={<Toplist />} />
        <Route path="/shop/:city/:category/:slug" element={<ShopDetails />} />
        <Route
          path="/vendorshop/:city/:category/:slug"
          element={<ListingShopDetails />}
        />
        <Route path="/see-allcategorys" element={<Seeallcategories />} />
        <Route
          path="/see-alltopratingshops"
          element={<Seealltopratingshops />}
        />
        <Route
          path="/see-allnearbyShopsSection"
          element={<SeeallnearbyShopsSection />}
        />
        <Route
          path="/see-allTopListSearches"
          element={<SeeallTopListSeraches />}
        />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignupFlow />} />
        <Route path="/profileinfo" element={<ProfileInformation />} />
        <Route path="/vendor-dashboard/*" element={<Dashboard />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/payment" element={<PaymentOptions />} />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        {/* <Route path="/dashboard" element={<AdminDashboard />} /> */}
        <Route path="/admin-settings" element={<AdminSettings />} />
        <Route
          path="/adminfinancial-management"
          element={<AdminFinancialManagement />}
        />
        {/* <Route path="/admin-profile" element={<AdminProfile />} /> */}
      <Route path="/vendor-login" element={<VendorLogin />} />
        <Route path="/addbuil-products" element={<Addbulkproducts />} />
        <Route path="/legalprivacy-policy" element={<LegalprivacyPolicy />} />
        <Route
          path="/communication-management"
          element={<CommunicationManagement />}
        />
        <Route path="/payment-management" element={<PaymentManagement />} />
        <Route
          path="/Returnand-RefundPolicy"
          element={<ReturnandRefundPolicy />}
        />
        <Route
          path="/integrationwith-deliverysystem"
          element={<IntegrationwithDeliverySystem />}
        />
        <Route path="/order-status" element={<OrderStatus />} />
        <Route path="/markert-promotions" element={<MarketingandPromotion />} />
        <Route path="/vendor-product" element={<VendorProduct />} />
        <Route path="/otp" element={<OTPVerification />} />
        <Route path="/vendorseller" element={<Vendorseller />} />
        {/* <Route path="/profile" element={<ProfilePage />} /> */}
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="/termsconditions" element={<Termsconditions />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/vendor-agreement" element={<Vendoragreement />} />
      </Routes>
      <SnackBarNotification />
      {showHeaderFooter && <Footer />}
    </PageShell>
  );
}
const AppWrapper = () => (
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>
);

export default AppWrapper;
